import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllAnnouncements } from '../api/announcementApi';
import { AnnouncementItemDto } from '../types/swagger-dtos/AnnouncementsDtos';

type AnnouncementsState = AnnouncementItemDto[] | null;

export const fetchAnnouncements = createAsyncThunk(
  'announcements/fetchAnnouncements',
  async (_, { dispatch }) => {
    const announcements = await getAllAnnouncements();
    dispatch(loadAnnouncements(announcements));
    return announcements;
  }
);

const announcementsSlice = createSlice({
  name: 'announcements',
  initialState: null as AnnouncementsState,
  reducers: {
    loadAnnouncements: (
      state,
      action: PayloadAction<AnnouncementItemDto[]>
    ) => {
      return action.payload;
    },
    updateAnnouncement: (state, action: PayloadAction<AnnouncementItemDto>) => {
      if (state === null) return state;
      return state.map((announcement) =>
        announcement.id === action.payload.id ? action.payload : announcement
      );
    },
    createAnnouncement: (state, action: PayloadAction<AnnouncementItemDto>) => {
      if (state === null) return state;
      return [...state, action.payload];
    },
    deleteAnnouncement: (state, action: PayloadAction<string | number>) => {
      if (state === null) return state;
      return state.filter((announcement) => announcement.id !== action.payload);
    },
  },
});

export const {
  loadAnnouncements,
  updateAnnouncement,
  createAnnouncement,
  deleteAnnouncement,
} = announcementsSlice.actions;

export default announcementsSlice.reducer;
